export const PREVIEW_SIZE = {
  square: {
    width: 500,
    height: 500,
  },
  portrait: {
    width: 400,
    height: 500,
  },
  landscape: {
    width: 500,
    height: 262,
  },
  reel: {
    width: 281,
    height: 500,
  },
  horizontal: {
    width: 500,
    height: 281,
  },
}
